import React, { useState, useEffect, useRef } from "react";

import WarningRow from "./WarningRow";
import { format } from "date-fns";
import ReactToPrint from "react-to-print";
import { connect } from "react-redux";
import { Actions as TIMESHEET_IMPORT_ACTIONS } from "../../../store/actions/timesheetImportActions";
import { Actions as EMPLOYEE_ACTIONS } from "../../../store/actions/employeeActions";

import TimesheetsOutsideOfRange from "./TimesheetsOutsideOfRange";
import Select from "react-select";
import _ from "lodash";
import {
	ArrowDownIcon,
	CheckCircleIcon,
	ChevronDownIcon,
	ChevronUpIcon,
	EyeSlashIcon,
	PrinterIcon,
} from "@heroicons/react/20/solid";
import { getEmploymentTypeName } from "@/common/validation/Validators";

const ImportWarnings = ({
	filename,
	importWarnings,
	notFoundWarnings,
	timesheetsOutsideOfRange,
	data,
	timesheetsPrepared,
	employees,
	employeesByReference,
	employeesUpdateListWithSalary,
	warningConditions,
	// ignore,
	setIgnore,
	processWarnings,
	linkEmployee,
	ignorePermanently,
}) => {
	const [collapse, setCollapse] = useState({});
	// const [showAll, setShowAll] = useState(false);

	useEffect(() => {
		// const collapseAll = {}
		// Object.keys(employeesByReference).map(reference => { collapseAll[reference] = true } )
		// console.log('collapse',collapseAll)
		// employeesByReference && setCollapse( collapseAll )
	}, [employeesByReference]);

	const fileName = `${importWarnings.length} Warnings for ${filename} on ${format(new Date(), "dd MMMM yyyy")}`;

	const warningTableRef = useRef();

	/*onBeforeGetContent={() => setShowAll(true)}
  onAfterPrint={() => setShowAll(false)}*/

	const renderWarningRows = (warning, index, importWarnings) => {
		const item = data[warning.index];
		if (!item) {
			// data has been cleared and warnings have not yet been
			return null;
		}

		const prevWarning = index > 0 && importWarnings[index - 1];
		const sameError =
			prevWarning &&
			warning.employeeByReference == prevWarning.employeeByReference &&
			warning.warningId == prevWarning.warningId;

		const rowClass = index % 2 == 1 ? "odd" : "even";

		const selectEmployeeReference = warning.warningId == "NF" && [
			<td
				colSpan="2"
				key="selector"
			>
				<Select
					style={{ maxWidth: "100px" }}
					value={
						employeesByReference[warning.employeeByReference] && {
							value: employeesByReference[warning.employeeByReference].id,
							label: `${employeesByReference[warning.employeeByReference].employeeName} ${
								employeesByReference[warning.employeeByReference].employeeSurname
							}`,
						}
					}
					onChange={(selectedOption) => {
						const newEmployees = [...employees];

						const employeeIndex = _.findIndex(employees, { id: selectedOption.value });
						const employee = {
							...employees[employeeIndex],
							reference: String(warning.employeeByReference),
						};

						newEmployees[employeeIndex] = employee;

						// TODO new action
						employeesUpdateListWithSalary({ employees: newEmployees });
					}}
					options={employees.map((employee) => ({
						value: employee.id,
						label: employee && `${employee.employeeName} ${employee.employeeSurname}`,
					}))}
				/>
			</td>,
			<td key="btn">
				{employeesByReference[warning.employeeByReference] && (
					<div
						className="btn btn-success"
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							linkEmployee(
								warning.employeeByReference,
								employeesByReference[warning.employeeByReference].id,
							);
						}}
					>
						<CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<div style={{ float: "left" }}>Confirm</div>
					</div>
				)}
				{!employeesByReference[warning.employeeByReference] && (
					<div
						className="btn btn-danger"
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							ignorePermanently(warning.employeeByReference);
						}}
					>
						<EyeSlashIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<div style={{ float: "left" }}>Ignore Permanently</div>
					</div>
				)}
			</td>,
		];

		// console.log('item',item)

		return [
			!sameError && (
				<tr
					key={item.reference + warning.warningId}
					role="row"
					className={rowClass}
				>
					<td className="font-w600">{item.reference}</td>
					<td className="font-w600">
						{employeesByReference[item.reference] && employeesByReference[item.reference].employeeName}{" "}
						{employeesByReference[item.reference] && employeesByReference[item.reference].employeeSurname}{" "}
						{employeesByReference[item.reference] &&
							getEmploymentTypeName(employeesByReference[item.reference].employmentTypeName)}
					</td>
					<td colSpan={selectEmployeeReference ? 2 : 5}>
						{_.find(warningConditions, { id: warning.warningId }).name}
					</td>
					{selectEmployeeReference}
					<td colSpan="1">
						<div
							className="btn btn-xs btn-default"
							style={{}}
							onClick={() => {
								const newCollapse = { ...collapse };
								newCollapse[item.reference + warning.warningId] =
									!collapse[item.reference + warning.warningId];
								setCollapse(newCollapse);
							}}
						>
							{!collapse[item.reference + warning.warningId] ? (
								<ChevronUpIcon style={{ height: "1.75em", float: "left" }} />
							) : (
								<ChevronDownIcon style={{ height: "1.75em", float: "left" }} />
							)}
						</div>
					</td>
				</tr>
			),
			!collapse[item.reference + warning.warningId] && (
				<WarningRow
					item={item}
					key={warning.key}
					rowclassName={rowClass}
					setItem={(newItem) => {
						const newData = [...data];

						newData[warning.index] = newItem;

						timesheetsPrepared(newData);
					}}
				/>
			),
		];
	};

	// const renderTimesheetsOutsideOfRange = (warning,index) => renderWarningRows(warning,index,timesheetsOutsideOfRange)
	const renderNotFoundWarnings = (warning, index) => renderWarningRows(warning, index, notFoundWarnings);
	const renderOtherWarnings = (warning, index) => renderWarningRows(warning, index, importWarnings);

	return (
		<div>
			<div className="pull-left">
				<h4>
					There are {importWarnings.length} Warnings identified when processing {filename}
				</h4>
			</div>

			{/*<div onClick={() => setShowAll(true)}>Show All</div>*/}
			<ReactToPrint
				trigger={() => (
					<div
						className="btn btn-default pull-right"
						style={{ marginRight: 10 }}
					>
						<PrinterIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<div style={{ float: "left" }}>Print Table</div>
					</div>
				)}
				content={() => warningTableRef.current}
			/>
			<a
				href="#"
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					window.scrollTo(0, document.body.scrollHeight);
				}}
				className="btn btn-default"
				style={{
					position: "fixed",
					right: "10px",
					top: "100px",
				}}
			>
				<ArrowDownIcon style={{ height: "1.5em", float: "left" }} />
			</a>
			<table
				className="table table-hover no-footer"
				role="grid"
				ref={warningTableRef}
			>
				<thead>
					<tr role="row">
						{/*<th className="sorting_disabled" rowspan="1" colspan="1" style="width: 45px;">
                    <label className="css-input css-checkbox css-checkbox-default remove-margin-t remove-margin-b">
                      <input type="checkbox" id="check-all-employee" name="check-all"><span />All
                    </label>
                  </th>*/}
						<th
							className="sorting_disabled"
							rowSpan="1"
							colSpan="1"
						>
							Reference
						</th>
						<th
							className="sorting_disabled"
							rowSpan="1"
							colSpan="1"
						>
							Employee
						</th>
						<th
							className="sorting_disabled"
							rowSpan="1"
							colSpan="1"
						>
							Date
						</th>
						<th
							className="sorting_disabled"
							rowSpan="1"
							colSpan="1"
						>
							Time-In
						</th>
						<th
							className="sorting_disabled"
							rowSpan="1"
							colSpan="1"
						>
							Time-Out
						</th>
						<th
							className="sorting_disabled"
							rowSpan="1"
							colSpan="1"
						>
							Hours
						</th>
						<th
							className="sorting_disabled"
							rowSpan="1"
							colSpan="1"
						>
							Break
						</th>
						<th
							className="sorting_disabled"
							rowSpan="1"
							colSpan="1"
						></th>
					</tr>
				</thead>
				<tbody>
					{timesheetsOutsideOfRange &&
						Object.keys(timesheetsOutsideOfRange).length > 0 &&
						Object.keys(timesheetsOutsideOfRange).map((reference, index) => (
							<TimesheetsOutsideOfRange
								key={reference}
								reference={reference}
								index={index}
							/>
						))}

					{notFoundWarnings && notFoundWarnings.map(renderNotFoundWarnings)}
					{importWarnings && importWarnings.map(renderOtherWarnings)}
				</tbody>
			</table>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		...state.timesheetImport,

		// ignore: state.timesheetImport.ignore,
		filename: state.timesheetImport.filename,

		data: state.timesheetImport.dataToSend,
		warningConditions: state.timesheetImport.warningConditions,
		showMappingSettings: state.timesheetImport.showMappingSettings,
		importWarnings: state.timesheetImport.warnings,
		timesheetsOutsideOfRange: state.timesheetImport.timesheetsOutsideOfRange,
		notFoundWarnings: state.timesheetImport.notFoundWarnings,
		employeesNotFound: state.timesheetImport.employeesNotFound,
		processingWarnings: state.timesheetImport.processingWarnings,

		employees: state.employees.employeeListWithSalary,
		employeesByReference: state.employees.employeesByReference,
	};
};

const mapDispatchToProps = (dispatch) => ({
	employeesUpdateListWithSalary: (employees) => dispatch(EMPLOYEE_ACTIONS.employeesUpdateListWithSalary(employees)),

	processWarnings: () => dispatch(TIMESHEET_IMPORT_ACTIONS.processWarnings()),
	prepareTimesheetImportForProcessing: () => dispatch(TIMESHEET_IMPORT_ACTIONS.prepareTimesheetImportForProcessing()),
	linkEmployee: (warning, reference) => dispatch(TIMESHEET_IMPORT_ACTIONS.linkEmployee(warning, reference)),
	ignorePermanently: (reference) => dispatch(TIMESHEET_IMPORT_ACTIONS.ignorePermanently(reference)),
	timesheetsPrepared: (data) => dispatch(TIMESHEET_IMPORT_ACTIONS.timesheetsPrepared(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportWarnings);
